import React, { useState}  from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";

import { Row } from "../../../utils/InputGroup";
import WithUserData from "../../WithUserData";
import { Checkbox } from "../../../utils/Checkbox-v2";
import { useMutation } from "@apollo/client";
import { UPDATE_USER_SKILLS } from "../../WithUserData/queries";
import {Link} from "react-router-dom";


const SkillsContent = ({ user }) => {
    const skillsList = [
        "Fashion model",
        "Influencer",
        "Content creator",
        "Photographer / Videographer",
        "Hair stylist / Makeup artist",
        "I'm a brand"
    ];

    const [checkedSkills, setCheckedSkills] = useState(user.skills || []);
    const [errorMessage, setErrorMessage] = useState(null);
    const [updateUserSkills] = useMutation(UPDATE_USER_SKILLS);

    const handleCheckedSkills = async (skill) => {
        const isRemoving = checkedSkills.includes(skill);
        const newCheckedSkills = isRemoving
            ? checkedSkills.filter((s) => s !== skill)
            : [...checkedSkills, skill];

        if (newCheckedSkills.length === 0) {
            setErrorMessage("At least one skill must be selected");
            setTimeout(() => setErrorMessage(null), 2000);
            return;
        }

        setCheckedSkills(newCheckedSkills);
        try {
            await updateUserSkills({
                variables: {
                    input:  {
                        id: user.id,
                        skills: newCheckedSkills
                    }
                }
            });
        } catch (e) {
            console.log("Error: failed to update skills", e);
        }
    };

    return (
        <div className='w-full h-full flex flex-col justify-between sm:justify-start'>
            <div className="w-full h-16 flex justify-between items-center mt-6 px-2">
                <Link
                    to="/account/edit-profile"
                    className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                >
                    <div className="w-10 flex items-center justify-center">
                        <MdOutlineArrowBackIos size={18} />
                    </div>
                    <span>Back</span>
                </Link>
                <div className="text-black text-2xl font-bold mr-10">Skills</div>
            </div>
            <div className="flex flex-col gap-4">
                <div className="w-full h-10 text-center text-red-600">{errorMessage}</div>
                {skillsList.map((skill) => (
                    <Row handleChecked={() => handleCheckedSkills(skill)} key={skill}>
                        <Checkbox label={skill} isChecked={checkedSkills.includes(skill)} theme='light' />
                    </Row>
                ))}
            </div>
        </div>
    );
};

const Skills = () => {
    return (
        <WithUserData>
            {({ user }) => <SkillsContent user={user} />}
        </WithUserData>
    );
};

export default Skills;